/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBookingGroupsVisitGroupId200, GetApiBookingGroupsVisitGroupId403, GetApiBookingGroupsVisitGroupId404, GetApiBookingGroupsVisitGroupId500, GetApiBookingGroupsVisitGroupIdPathParams, GetApiBookingGroupsVisitGroupIdQueryParams, GetApiBookingGroupsVisitGroupIdQueryResponse } from "../entities/GetApiBookingGroupsVisitGroupId";
import { modelsBookingGroupOutputSchema } from "./models/bookingGroupOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const getApiBookingGroupsVisitGroupIdPathParamsSchema = z.object({
    "visit_group_id": z.string().describe("ID группы записей")
    }) as unknown as z.ZodType<GetApiBookingGroupsVisitGroupIdPathParams>

export const getApiBookingGroupsVisitGroupIdQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiBookingGroupsVisitGroupIdQueryParams>

/**
 * @description OK
 */
export const getApiBookingGroupsVisitGroupId200Schema = z.lazy(() => modelsBookingGroupOutputSchema) as unknown as z.ZodType<GetApiBookingGroupsVisitGroupId200>

/**
 * @description Forbidden
 */
export const getApiBookingGroupsVisitGroupId403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBookingGroupsVisitGroupId403>

/**
 * @description Not Found
 */
export const getApiBookingGroupsVisitGroupId404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBookingGroupsVisitGroupId404>

/**
 * @description Internal Server Error
 */
export const getApiBookingGroupsVisitGroupId500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBookingGroupsVisitGroupId500>

export const getApiBookingGroupsVisitGroupIdQueryResponseSchema = z.lazy(() => getApiBookingGroupsVisitGroupId200Schema) as unknown as z.ZodType<GetApiBookingGroupsVisitGroupIdQueryResponse>